// import PropTypes from 'prop-types'

import { Root } from './Subheader.style'

const Subheader = ({ children, ...props }) => {
  return <Root {...props}>{children}</Root>
}

Subheader.propTypes = {}

Subheader.defaultProps = {}

export default Subheader
